import { defineMessages } from 'react-intl';

export const i18n: {
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterTypePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	type: {
		id: 'search-page.filters.names.type',
		defaultMessage: 'Type',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow results by content or result type.',
	},
	filterTypePlaceholder: {
		id: 'search-page.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
});
